import { createStore } from 'vuex'

import actions from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'

// This is the store for the full discussion forum component.
export default function buildStore() {
  return createStore({
    state,
    getters,
    actions,
    mutations
  })
}
